<script lang="ts">
	import { ETheme } from '$lib/dto/ETheme';
	import { appTheme } from '$lib/utils/themeUtils';
	import vs2015 from 'svelte-highlight/styles/vs2015';
	import xcode from 'svelte-highlight/styles/xcode';
</script>

<svelte:head>
	{#if $appTheme === ETheme.Dark}
		{@html vs2015}
	{:else}
		{@html xcode}
	{/if}
</svelte:head>
